import { Skeleton } from '@/shared/ui/skeleton'
import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'

export type ReviewListPendingProps = {}

export const ReviewListPending = ({
  className,
  ...props
}: ReviewListPendingProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn(className)} {...props}>
      <div className="flex items-baseline gap-1">
        <Skeleton className="h-10 w-[150px]" />
        <Skeleton className="ml-2 h-8 w-[50px]" />
      </div>
      <div className="mt-4 flex items-center gap-1">
        <Skeleton className="h-8 w-[100px]" />
      </div>
      <div className="mt-4 flex gap-3 overflow-x-scroll scrollbar-hide">
        {[...Array(5)].map((_, index) => (
          <Skeleton key={index} className="h-[80px] w-[200px]" />
        ))}
      </div>
    </div>
  )
}
